import { z } from "zod";
import { isValidName } from "@/utils/is-valid-name";

export const useContactFormSchema = () => {
  return z.object({
    name: z
      .string()
      .trim()
      .min(1, "Please enter a valid full name.")
      .max(100, "Please enter a valid full name.")
      .refine(isValidName, "Please enter a valid full name."),
    company: z
      .string()
      .trim()
      .min(1, "Please enter a valid company name.")
      .max(100, "Please enter a valid company name.")
      .refine(isValidName, "Please enter a valid company name."),
    phone: z
      .string()
      .min(7, "Phone number is too short.")
      .max(15, "Phone number is too long.")
      .regex(/^[0-9+\-\s()]+$/, "Invalid phone number."),
    email: z.email("Please enter a valid email address."),
    message: z.string().min(6, "Please enter atlease more than 6 characters."),
  });
};
